import { toast } from "react-toastify";
import { copy, share } from "../../../resources/js/icons";
import H4 from "../../../shared/typography/H4";
import P from "../../../shared/typography/P";

const ShareLinkForm = ({ url }) => {
    const textToCopy = `Join Our Solar Community.  

    You can earn up to 20% returns, and your society will benefit from significant savings on electricity bills. It's a win-win for everyone!  
    Together, our small contributions can make a big difference.  
    
    ${url}
    `;

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            toast.success("Text copied to clipboard!");
        } catch (err) {
            toast.error("Failed to copy the text");
        }
    };
    return (
        <div className="p-4 lg:p-2">
            <div className=" flex flex-col items-center justify-center gap-2">
                <H4 className="mt-2 text-center">Invite Members</H4>
                <div className="flex justify-center items-center">
                    <img src={share} alt="share" className="w-8 h-8" />
                </div>
                <P className="text-center">
                    Invite your friends and family to invest in the solar
                    project. Together, our small contributions can make a big
                    difference.
                </P>
                <div className="flex w-full  justify-between md:justify-center  items-center  gap-1">
                    <div className="text-base xs:w-[80%] bg-background border border-blue-300  rounded-sm">
                        <div className=" px-0.5 line-clamp-1 text-center text-xs xs:text-sm md:text-sm xl:text-sm font-normal font-vietnam  py-0.8 text-blue ">
                            <a>{url}</a>
                        </div>
                    </div>
                    <div
                        className=" rounded-sm   border p-0.5 border-gray-550 flex items-center justify-center"
                        role="button"
                        onClick={() => copyToClipboard()}
                    >
                        <img src={copy} alt="copy" className="h-3 w-3" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareLinkForm;
